import React from 'react';
import AppLayout from '../components/app/AppLayout';
import GoalsPlaceholder from '../components/app/GoalsPlaceholder';

function GoalsPage() {
  return (
    <AppLayout>
      <GoalsPlaceholder />
    </AppLayout>
  );
}

export default GoalsPage;








